import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Disconnect: React.FC<IconProps> = () => {
  return (
    <svg width="150" height="151" viewBox="0 0 150 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M75 150.65C116.421 150.65 150 117.072 150 75.6501C150 34.2288 116.421 0.650146 75 0.650146C33.5786 0.650146 0 34.2288 0 75.6501C0 117.072 33.5786 150.65 75 150.65Z"
        fill="#EAECF0"
      />
      <mask id="mask0_9584_33195" maskUnits="userSpaceOnUse" x="0" y="0" width="150" height="151">
        <path
          d="M75 150.65C116.421 150.65 150 117.072 150 75.6501C150 34.2288 116.421 0.650146 75 0.650146C33.5786 0.650146 0 34.2288 0 75.6501C0 117.072 33.5786 150.65 75 150.65Z"
          fill="url(#paint0_linear_9584_33195)"
        />
      </mask>
      <g mask="url(#mask0_9584_33195)">
        <path
          d="M78.1583 114.514V162.675C78.1583 171.013 71.395 177.773 63.0524 177.773H-9.89528C-16.0972 177.773 -21.1254 182.798 -21.1254 188.997V220.063C-21.1254 221.133 -21.9924 221.999 -23.0627 221.999C-24.133 221.999 -25 221.133 -25 220.063V188.997C-25 180.659 -18.2367 173.9 -9.89528 173.9H63.0536C69.2555 173.9 74.2825 168.876 74.2825 162.677V114.514H78.1595H78.1583Z"
          fill="#4D5A79"
        />
        <path
          d="M82.518 124.909V132.627C82.518 134.47 81.0231 135.963 79.1797 135.963H73.2596C72.2416 135.963 71.3307 135.508 70.7194 134.791C70.2223 134.208 69.9214 133.453 69.9214 132.627V124.909H82.5168H82.518Z"
          fill="#66758D"
        />
        <path
          d="M89.0984 106.918V122.334C89.0984 124.715 87.1671 126.646 84.7838 126.646H67.6562C65.2741 126.646 63.3428 124.715 63.3428 122.334V106.918H89.0984Z"
          fill="#98A2B3"
        />
        <path
          d="M61.8084 106.919H90.6312C90.9438 106.919 91.1973 106.666 91.1973 106.353V104.09C91.1973 103.778 90.9438 103.524 90.6312 103.524H61.8084C61.4958 103.524 61.2423 103.778 61.2423 104.09V106.353C61.2423 106.666 61.4958 106.919 61.8084 106.919Z"
          fill="#98A2B3"
        />
        <path
          d="M72.3549 103.523H67.9653V93.0311C67.9653 91.8199 68.9477 90.8381 70.1595 90.8381C71.3714 90.8381 72.3537 91.8199 72.3537 93.0311V103.523H72.3549Z"
          fill="#3C4960"
        />
        <path
          d="M82.2803 90.8381C83.4922 90.8381 84.4745 91.8211 84.4745 93.0311V103.523H80.085V93.0311C80.085 91.8199 81.0685 90.8381 82.2791 90.8381H82.2803Z"
          fill="#3C4960"
        />
        <path d="M89.0984 106.918H63.3428V108.161H89.0984V106.918Z" fill="#66758D" />
        <path
          d="M89.0982 113.434V122.334C89.0982 124.715 87.1669 126.645 84.7836 126.645H72.7603C84.9025 126.645 89.0982 113.434 89.0982 113.434Z"
          fill="#66758D"
        />
        <path d="M82.5182 126.646H69.9229V127.451H82.5182V126.646Z" fill="#3C4960" />
        <path d="M72.3559 101.988H67.9663V103.523H72.3559V101.988Z" fill="#15172D" />
        <path d="M84.4745 101.988H80.085V103.523H84.4745V101.988Z" fill="#15172D" />
        <path
          d="M82.5183 126.645V132.627C82.5183 134.47 81.0234 135.963 79.1801 135.963H73.26C72.242 135.963 71.331 135.508 70.7197 134.791C79.9472 135.921 81.3564 126.644 81.3564 126.644H82.5183V126.645Z"
          fill="#3C4960"
        />
        <path
          d="M194 -24.0635C194 -22.9937 193.132 -22.126 192.062 -22.126H89.3886C83.1867 -22.126 78.1585 -17.1005 78.1585 -10.9019V39.9937H74.2827V-10.9019C74.2827 -19.2401 81.0448 -25.9998 89.3886 -25.9998H192.062C193.132 -25.9998 194 -25.1321 194 -24.0635Z"
          fill="#4D5A79"
        />
        <path
          d="M82.518 35.635V27.9173C82.518 26.0737 81.0231 24.5808 79.1797 24.5808H73.2596C72.2416 24.5808 71.3307 25.0361 70.7194 25.7528C70.2223 26.3364 69.9214 27.0912 69.9214 27.9173V35.635H82.5168H82.518Z"
          fill="#66758D"
        />
        <path
          d="M89.0984 53.6272V38.2108C89.0984 35.83 87.1671 33.8997 84.7838 33.8997H67.6562C65.2741 33.8997 63.3428 35.83 63.3428 38.2108V53.6272H89.0984Z"
          fill="#98A2B3"
        />
        <path
          d="M61.8084 57.0208L90.6312 57.0208C90.9438 57.0208 91.1973 56.7674 91.1973 56.455V54.1918C91.1973 53.8794 90.9438 53.626 90.6312 53.626H61.8084C61.4958 53.626 61.2423 53.8794 61.2423 54.1918V56.455C61.2423 56.7674 61.4958 57.0208 61.8084 57.0208Z"
          fill="#98A2B3"
        />
        <path d="M89.0984 52.3838H63.3428V53.6271H89.0984V52.3838Z" fill="#66758D" />
        <path
          d="M89.0982 47.1112V38.2108C89.0982 35.83 87.1669 33.8997 84.7836 33.8997H72.7603C84.9025 33.8997 89.0982 47.1112 89.0982 47.1112Z"
          fill="#66758D"
        />
        <path d="M82.5182 33.0938H69.9229V33.8996H82.5182V33.0938Z" fill="#3C4960" />
        <path
          d="M82.5183 33.8984V27.9173C82.5183 26.0737 81.0234 24.5808 79.1801 24.5808H73.26C72.242 24.5808 71.331 25.0361 70.7197 25.7528C79.9472 24.6224 81.3564 33.8996 81.3564 33.8996H82.5183V33.8984Z"
          fill="#3C4960"
        />
        <path
          d="M42.4381 70.483H34.4629C33.8564 70.483 33.3652 69.9921 33.3652 69.3859C33.3652 68.7797 33.8564 68.2888 34.4629 68.2888H42.4381C43.0446 68.2888 43.5357 68.7797 43.5357 69.3859C43.5357 69.9921 43.0446 70.483 42.4381 70.483Z"
          fill="#98A2B3"
        />
        <path
          d="M52.5596 60.3667C51.9531 60.3667 51.4619 59.8759 51.4619 59.2697V51.2988C51.4619 50.6926 51.9531 50.2017 52.5596 50.2017C53.1661 50.2017 53.6573 50.6926 53.6573 51.2988V59.2697C53.6573 59.8759 53.1661 60.3667 52.5596 60.3667Z"
          fill="#98A2B3"
        />
        <path
          d="M45.2419 63.1695C44.9612 63.1695 44.6806 63.0625 44.4653 62.8486L38.9876 57.3738C38.5595 56.9447 38.5595 56.2505 38.9876 55.8226C39.4157 55.3947 40.1114 55.3947 40.5396 55.8226L46.0173 61.2974C46.4466 61.7253 46.4466 62.4207 46.0173 62.8486C45.8032 63.0625 45.5226 63.1695 45.2407 63.1695H45.2419Z"
          fill="#98A2B3"
        />
        <path
          d="M110.002 95.1685H117.977C118.584 95.1685 119.075 95.6594 119.075 96.2656C119.075 96.8717 118.584 97.3626 117.977 97.3626H110.002C109.395 97.3626 108.904 96.8717 108.904 96.2656C108.904 95.6594 109.395 95.1685 110.002 95.1685Z"
          fill="#98A2B3"
        />
        <path
          d="M99.8814 105.283C100.488 105.283 100.979 105.774 100.979 106.381V114.351C100.979 114.958 100.488 115.449 99.8814 115.449C99.2749 115.449 98.7837 114.958 98.7837 114.351V106.381C98.7837 105.774 99.2749 105.283 99.8814 105.283Z"
          fill="#98A2B3"
        />
        <path
          d="M107.199 102.482C107.479 102.482 107.76 102.589 107.975 102.803L113.453 108.278C113.881 108.706 113.881 109.401 113.453 109.829C113.025 110.257 112.329 110.257 111.901 109.829L106.423 104.354C105.995 103.925 105.994 103.231 106.423 102.803C106.637 102.589 106.918 102.482 107.2 102.482H107.199Z"
          fill="#98A2B3"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_9584_33195" x1="75" y1="0.650146" x2="75" y2="150.65" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3ECFA" />
          <stop offset="1" stopColor="#DAE7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Disconnect;
